import axios from "axios";
import { variables } from "../../environments";

let config = {
  headers: {
    "Content-Type": "application/json",
  },
};
const BASE = variables.WHOLESALE_URL;

const getToken = async () => {
  let token;
  let authData = localStorage.getItem("userAuth");
  let onBehalfRetCode = localStorage.getItem("onBehalfRetCode");
  let userData = JSON.parse(localStorage.getItem("userData"));
  if (authData && JSON.parse(authData).data.jwtToken) {
    token = JSON.parse(authData).data.jwtToken;
  }
  config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  if (
    onBehalfRetCode &&
    onBehalfRetCode.length > 0 &&
    onBehalfRetCode != "undefined" &&
    (userData.admin || userData.salesPerson)
  ) {
    config.headers.adminRetailerCode = onBehalfRetCode;
    config.headers.source="wholesaleWebOnbehalf"
  }
  return true;
};

export const getLiveOrders = async (params) => {
  const data = getToken().then(() => {
    config.headers.appVersionCode = 160;
    return axios.get(`${BASE}/wholesale/home/fetchLiveOrders`, {
      params: params,
      headers: config.headers,
    });
  });
  return data;
};

export const getPastOrders = async (params) => {
  const data = getToken().then(() => {
    config.headers.appVersionCode = 160;
    return axios.get(`${BASE}/wholesale/home/fetchPastOrders`, {
      params: params,
      headers: config.headers,
    });
  });
  return data;
};

export const getOrderTrackingStatus = async (params) => {
  const data = getToken().then(() => {
    config.headers.appVersionCode = 160;
    return axios.get(`${BASE}/wholesale/home/getOrderTrack`, {
      params: params,
      headers: config.headers,
    });
  });
  return data;
};
